import { _ } from 'numeral';
import useGraphQLClient from './graphqlClient';
import {
  TagsWhereInput,
  TagsOrderByWithRelationInput,
  Tags,
  SortOrder,
} from './spotwrite';

/**
 * 作品の検索条件
 */
export type TagsSearchCondition = {
  limit?: number;
  offset?: number;
  orderBy?: TagsOrderByWithRelationInput[];
};

class TagService {
  client = useGraphQLClient();

  /**
   * 検索条件を整形します
   * @param condition
   * @returns
   */
  private buildSearchWhere = (condition: TagsSearchCondition) => {
    const andWhere: TagsWhereInput[] = [];

    return {
      AND: andWhere,
    };
  }

  /**
   * タグを検索
   * @param where
   */
  public async search(condition: TagsSearchCondition) {
    // 検索条件ビルド
    const where = this.buildSearchWhere(condition);
    try {
      const res = await this.client.findManyTags({
        where,
        take: condition.limit,
        skip: condition.offset,
        orderBy: condition.orderBy,
      });
      if (res.findManyTags) {
        return res.findManyTags.filter((item) => (item._count && item._count.productionTags));
      }
      return [] as Tags[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * 新着お知らせを取得
   * @param limit
   */
  public popular = async (limit: number) => {
    const condition: TagsSearchCondition = {
      limit: limit > 0 ? limit : 10,
      orderBy: [
        {
          productionTags: {
            _count: SortOrder.Desc,
          },
        },
      ],
    };
    return this.search(condition);
  }

  /**
   * 名称を指定してTagを取得
   * @param name
   * @returns
   */
  public getByName = async (name: string) => {
    const client = useGraphQLClient();
    try {
      const exist = await client.findFirstTags({
        where: { name: { equals: name } },
      });
      return exist.findFirstTags;
    } catch (error) {
      console.log(error);
    }
    return null;
  }

  /**
   * Tagを登録します
   * @param data
   */
  public create = async (data: any) => {
    if (!data.name) return null;
    const client = useGraphQLClient();

    const existTag = await this.getByName(data.name);
    // すでに存在する場合は、既存のデータを返却
    if (existTag) return existTag;
    try {
      // 新規作成
      const res = await client.createOneTags({
        data: {
          name: data.name,
        },
      });
      return res.createOneTags;
    } catch (error) {
      console.log(error);
    }
    return null;
  }
}
export default new TagService();
